
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ort-vorschlagen",
      function () {
        return require("private-next-pages/ort-vorschlagen.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ort-vorschlagen"])
      });
    }
  